// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"97886661","458":"ca725f8d","519":"d9ccbdee","774":"8be3cdec","787":"0f1cb802","819":"dfa3d2e3","858":"86d62149","910":"189c3284"}[chunkId] + ".chunk.js";
};